<template>
  <panel title="Tools">
    <a class="btn btn-danger" @click.prevent="cleanSales()">Clean all sales</a>
  </panel>
</template>

<script>
import Panel from '@/components/_partial/_atomic/panel'
import ConfigService from '@/services/config.service'

export default {
  name: 'Index',
  components: { Panel },

  data () {
    return {
      service: ConfigService
    }
  },

  methods: {
    cleanSales () {
      this.$popup.confirm('Are you sure you want to clean all sales and make all apartments available?', 'Confirm action').then(() => {
        this.service.cleanSales(() => {
          this.$popup.success('All done')
        })
      })
    }
  }
}
</script>

<style scoped>

</style>
